<template>
  <div>
    <!-- test layout -->
    <v-container grid-list-xl>
      <h2>Validacije</h2>
      <v-divider></v-divider>
      <br>
      <v-layout v-bind="contentLayout">
        <v-flex>
          <v-card>
            <v-card-text>
              <v-form>
                <v-select
                  :items="parkirisca"
                  v-model="parkirisce"
                  label="Izberi parkirišče"
                  item-text="text"
                  item-value="st_park"
                  @change="setFocus"
                  auto 
                ></v-select>
                <v-text-field
                  v-model="barcode"
                  label="Približaj listek k čitalcu ..."
                  @keyup.enter.native="validiraj"
                  :disabled="!disableScan"
                  ref="scan_input"
                ></v-text-field>
                <!--<v-btn
                  @click="submit"
                >
                  Validiraj
                </v-btn>-->
                <!--<v-btn @click="clear">Počisti</v-btn>-->
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex> 
      </v-layout>
    </v-container>

    <v-container grid-list-xl>
      <v-layout v-bind="contentLayout">
        <v-flex>
          <v-card >
            <v-card-title>
              Zadnje validacije
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Išči..."
                single-line
                hide-details
              ></v-text-field>
              
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="validacije"
              :search="search"
              no-results-text="Test"
              rows-per-page-text="Prikaz zapisov"
              :rows-per-page-items="rowsPerPage"
              :loading="validacijeTableLoading"

            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id }}</td>
                <td class="text-xs-left">{{ props.item.ParkNum }}</td>
                <td class="text-xs-left">{{ props.item.Parkirisce }}</td>
                <td class="text-xs-left">{{ props.item.SerNum }}</td>
                <td class="text-xs-left">{{ props.item.ParkingTime }}</td>
              </template>
              <div slot="no-results" :value="true" style="text-align:center;">
                  Nobeden zapis ne ustreza iskanemu nizu.
              </div>
              <div slot="no-data" style="text-align:center;">
                Ni podatkov za prikaz.
              </div>
              <template slot="pageText" slot-scope="props">
                Prikazujem {{ props.pageStart }} - {{ props.pageStop }} od {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
        <v-tooltip left v-show="hasPermissons">
          <v-btn
          fixed
          dark
          fab
          bottom
          right
          color="light-blue darken-3"
          @click="usersList"
          slot="activator"
          >
          <v-icon>format_list_bulleted</v-icon>
          </v-btn>
          <span>Seznam uporabnikov</span>
        </v-tooltip>
      </v-layout>
    </v-container>
    <!-- /test layout -->
  </div>  
</template>

<script>
  export default {
    data () {
      return {
        barcode: '',
        valid: true,
        search: '',
        headers: [
          {
            text: '#',
            align: 'left',
            sortable: false,
            value: 'id'
          },
          { text: 'Št. parkirišča', value: 'ParkNum', sortable: false },
          { text: 'Parkirišče', value: 'Parkirisce', sortable: false },
          { text: 'Št. listka', value: 'SerNum', sortable: false },
          { text: 'Čas validacije', value: 'ParkingTime', sortable: false },
        ],

        //select
        //e1: { id: 3, st_park: "0005-5", text: "Zdravstveni dom"},
        e1: this.parkirisce,
        items: [
        ],

        rowsPerPage: [5, 10, 25, 50],
        validacijeLoadingError: false,
        validacijeTableLoading: false
      }
    },

    watch: {
      e1(val) {
        this.$store.commit('setParkirisce', val)
        /*this.items.forEach(function(item) {
          if(item.st_park == val) {
            this.$store.commit('setParkirisce', item)
          }
        })*/
      }
    },

    computed: {
      currentUser() {
        return this.$store.getters.user.name
      },

      parkirisce: {
        get() {
          let parkirisce = this.$store.getters.parkirisce
          return parkirisce
        },

        set(newValue) {
          this.$store.commit('setParkirisce', newValue)
        }

      },

      contentLayout () {
        const binding = {}

        if(this.$vuetify.breakpoint.lgAndUp) {
          binding.column = false
        } else {
          binding.column = true
        }

        return binding;
      } ,

      disableScan() {
        return (this.parkirisce == null) ? false : true;
      },

      parkirisca() {
        return this.$store.getters.parkirisca
      },

      validacije() {
        return this.$store.getters.validacije
      },

      hasPermissons() {
        if(this.$store.getters.permissions.includes('root') || this.$store.getters.permissions.includes('rfid_uporabniki')) {
          return true;
        }

        return false;
      }
      
      /*validacijeError() {
        return this.validacijeLoadingError
      }*/
    },

    methods: {

      submit() {
        window.consoleconsole.log("Validiraj: " + this.barcode);
      },

      validiraj() {
          this.addValidacija({
            ParkNum: this.parkirisce,
            SerNum: this.barcode
          })
      },

      getRandomInt(max) {
        return Math.floor(Math.random() * Math.floor(max));
      },

      addValidacija(item) {
        this.$toasted.show("Validacija " + this.barcode + ' je v teku...', {
          position: 'bottom-right',
          duration: 5000,
          icon: 'hourglass_empty',
          theme: 'outline', //['primary', 'outline' , 'bubble']
          closeOnSwipe: true
        })
        this.$store.dispatch('STORE_VALIDACIJA', item)
          .then(response => {
            this.$toasted.show("Validicija " + this.barcode + " je uspela.", {
              position: 'bottom-right',
              duration: 5000,
              icon: 'done',
              theme: 'outline', //['primary', 'outline' , 'bubble']
              closeOnSwipe: true
            })
          })
          .catch(error =>{
            window.console.log("Napaka - Validacija listka: " + this.barcode)
            window.console.log(error.response)
            this.$toasted.show("Validicija " + this.barcode + " ni uspela.", {
              position: 'bottom-right',
              duration: 5000,
              icon: 'error_outline',
              theme: 'bubble', //['primary', 'outline' , 'bubble']
              closeOnSwipe: true
            })
          })
          .then(() =>{
            this.barcode = '';
          })
      },

      setFocus() {
        if(this.parkirisce != null) {
          this.$refs.scan_input.focus()
        }
      },

      usersList() {
            this.$router.push({
                name: 'seznam-uporabnikov'
            })
        }
    },

    created() {
      this.validacijeTableLoading = true
      this.$store.dispatch('VALIDACIJE')
        .then(response => {
          //console.log(response.data)
          this.validacijeTableLoading = false
        })
        .catch(error => {
          this.$toasted.show("Pri pridobivanju podatkov je prišlo do napake.", {
            position: 'bottom-right',
            duration: 5000,
            icon: 'error_outline',
            theme: 'bubble', //['primary', 'outline' , 'bubble']
            closeOnSwipe: true
          })
          //this.validacijeLoadingError = true
          this.validacijeTableLoading = false
          console.log(error)
        })
        .then(() => {
          this.validacijeTableLoading = false
        })
    },

    mounted() {
      this.validacijeTableLoading = true
      this.setFocus()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
